import { Component, Input, OnInit } from '@angular/core';
import { Agrupacion, CREDITOS_VIGENTES } from '../../../../../_models/perfil-cliente/creditos-vigentes';

@Component({
  selector: 'app-vectores-pago-crezcamos',
  templateUrl: './vectores-pago-crezcamos.component.html',
  styleUrls: ['./vectores-pago-crezcamos.component.scss']
})
export class VectoresPagoCrezcamosComponent implements OnInit {
  @Input() informacionPerfil: any;
  resumenCreditos: Agrupacion[] = [];
  arrayTitleColumns: string[] = CREDITOS_VIGENTES;
  ngOnInit(): void {
    const agrupacion = this.informacionPerfil.creditosVigentes.agrupacion;

    this.resumenCreditos = agrupacion.map((item:Agrupacion) => ({
      rol: item.participacion,
      cantidad: item.cantidad,
      cuota: item.cuota,
      pagoTotal: item.pagoTotal,
      diasMora: item.diasMora,
      valorMora: item.valorMora,
      indicadorBandera: item.indicadorBandera
    }));

    const total = {
      rol: 'TOTAL',
      cantidad: this.informacionPerfil.creditosVigentes.cantidad,
      cuota: this.informacionPerfil.creditosVigentes.cuota,
      pagoTotal: this.informacionPerfil.creditosVigentes.pagoTotal,
      diasMora: this.informacionPerfil.creditosVigentes.diasMora,
      valorMora: this.informacionPerfil.creditosVigentes.valorMora,
      indicadorBandera: false
    };
    this.resumenCreditos.push(total);
  }
}
